<template>
  <div class="advertisement">
    <headerNotice routerName='添加广告' />
    <div class="content">
      <h1>添加广告</h1>
      <div class="ad-temp-wrapper">
        <adTemp ref='adTemp' @sendData='creatAd' :type='0' :data='adDetails' v-loading="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import adTemp from "./adTemp.vue";
export default {
  components: {
    headerNotice,
    adTemp
  },
  props: {},
  data() {
    return {
      loading: false,
      adDetails: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    creatAd(form, type) {
      if (type) {
        return;
      }
      let self = this;
      let adTemp = self.$refs.adTemp;
      adTemp.loading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminAdvertising/Create",
        data: form,
        success(res) {
          self.$message({
            showClose: true,
            message: "操作成功！",
            type: "success"
          });
          // adTemp.form = {}
          adTemp.loading = false;
          self.$router.push({
            path: "/advertisingList"
          });
        },
        fail(res) {
          adTemp.loading = false;
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.advertisement {
  .content {
    margin: 20px 50px 0;
    border: 1px solid #e4e4e4;
  }
  h1 {
    padding-left: 20px;
    background: #f3f3f3;
    line-height: 50px;
  }
  .ad-temp-wrapper {
    width: 600px;
    margin: 50px auto;
  }
}
</style>
